type PBAEventPayload = {
  eventType: 'EVENT';
  eventName: string;
  eventValue?: Record<string, unknown>;
};

export default function trackAppsFlyerEvent(
  eventName: string,
  eventValue?: Record<string, unknown>,
) {
  if (globalThis.window === undefined) return;

  const AF = (globalThis.window as any).AF;
  if (typeof AF !== 'function') return;

  const payload: PBAEventPayload = {
    eventType: 'EVENT',
    eventName,
    eventValue,
  };

  AF('pba', 'event', payload);
}
